const savedClass = 'u-lightswitch--saved'
const errorClass = 'u-lightswitch--error'

function handleSubscriptionToggle(response) {
  const target = response.target

  if (!target.classList.contains('js-subscription-toggle')) {
    return
  }

  if (response.type === 'ajax:error') {
    target.checked = !target.checked
  }

  const statusClass = response.type === 'ajax:success' ? savedClass : errorClass
  target.classList.add(statusClass)
  target.dataset['params'] = target.dataset['params'].replace(
    /value=(true|false)/,
    'value=' + !target.checked
  )

  setTimeout(() => {
    target.classList.remove(statusClass)
  }, 3000)
}

document.addEventListener('ajax:success', handleSubscriptionToggle)
document.addEventListener('ajax:error', handleSubscriptionToggle)
